"use client"

import clsx from "clsx"

import Slider from "@unlikelystudio/react-slider"

import type { PropsWithClassName } from "~/@types/generics"
import NavigationCta from "~/components/ui/Layouts/SideNavHeaderLayout/components/SideNavigation/components/NavigationCta"
import type { LinkProps } from "~/components/ui/Link"

import { sprinkles } from "~/styles/sprinkles.css"

import * as css from "./styles.css"

type ClientSideNavigationProps = PropsWithClassName<{ ctas: LinkProps[] }>
function ClientSideNavigation({ ctas, className }: ClientSideNavigationProps) {
  const links = ctas.map((cta, key) => (
    <NavigationCta className={css.item} key={`logged_navigation_item_${key}`} {...cta} />
  ))

  return (
    <>
      <nav
        className={clsx(
          css.SideNavigation,
          sprinkles({
            display: { mobile: "none", desktop: "flex" },
            flexDirection: "column",
          }),
          className
        )}
      >
        {links}
      </nav>
      <nav
        className={clsx(
          css.SideNavigation,
          sprinkles({
            display: { mobile: "flex", desktop: "none" },
          })
        )}
      >
        <Slider
          className={clsx(
            css.slider,

            className
          )}
        >
          {links}
        </Slider>
      </nav>
    </>
  )
}

export { ClientSideNavigation }
